import React, { useContext, useState } from 'react'
import Button from '@Components/Buttons/Button'
import Popup from '@Components/Popups/Popup'
import { StoresContext } from '@App/contexts'
import { CatalogTransferReviewDecisionStatus } from '@Entities/rightsholder/catalog-transfer-view'

interface ReviewDecisionPopupProps {
    decision: CatalogTransferReviewDecisionStatus | null
    onSubmit: (notes: string) => void
    onClose: () => void
}

const decisionCopyByDecision: Record<
    CatalogTransferReviewDecisionStatus,
    { title: string; description: string; confirmText: string }
> = {
    APPROVE: {
        title: 'Are you sure you want to approve this catalog transfer?',
        description: 'Once you click Approve the selected works will be transferred and cannot be undone.',
        confirmText: 'Approve',
    },
    DENY: {
        title: 'Are you sure you want to deny this catalog transfer?',
        description: 'Once you click Deny the catalog transfer will be rejected and cannot be undone.',
        confirmText: 'Deny',
    },
} as const

const ReviewDecisionPopup = ({ decision, onSubmit, onClose }: ReviewDecisionPopupProps) => {
    const { userStore } = useContext(StoresContext)
    const [decisionNotes, setDecisionNotes] = useState('')
    if (!decision) {
        return null
    }
    const decisionCopy = decisionCopyByDecision[decision]
    const decisionDisabled = userStore.isInternal || (decision === 'DENY' && !decisionNotes.trim())

    return (
        <Popup onClose={onClose} showClose className="ct-decision-popup">
            <div className="ct-decision-popup-inner">
                <h2>{decisionCopy.title}</h2>
                <p>{decisionCopy.description}</p>
                {decision === 'DENY' && (
                    <div className="ct-decision-popup-notes">
                        <label htmlFor="ct-decision-notes">Notes (required)</label>
                        <textarea
                            id="ct-decision-notes"
                            value={decisionNotes}
                            onChange={(event) => setDecisionNotes(event.target.value)}
                            placeholder="Required"
                        />
                    </div>
                )}
                <div className="ct-decision-popup-actions">
                    <Button
                        mainColor
                        type="primary-small"
                        onClick={() => onSubmit(decisionNotes)}
                        disabled={decisionDisabled}
                    >
                        {decisionCopy.confirmText}
                    </Button>
                </div>
            </div>
        </Popup>
    )
}

export default ReviewDecisionPopup
